'use strict';

const AllowedBookingRequestDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const AllowedBookingRequestDTOTransportMode = {
    Sea: 'sea',
    Air: 'air',
    Rail: 'rail',
    Road: 'road'
};
const AllowedBookingRequestDTOIncoterm = {
    Exw: 'EXW',
    FcaLw: 'FCA_LW',
    FcaT: 'FCA_T',
    Fas: 'FAS',
    Fob: 'FOB',
    Cfr: 'CFR',
    Cif: 'CIF',
    Cpt: 'CPT',
    Cip: 'CIP',
    Dpu: 'DPU',
    Dap: 'DAP',
    Ddp: 'DDP'
};
const AssignedOpsChangedDTOType = {
    AssignedOpsChanged: 'assignedOpsChanged'
};
const AssignmentDetailsDTOAssignedSide = {
    Origin: 'origin',
    Destination: 'destination'
};
const AuthorizedDTOType = {
    Authorized: 'authorized'
};
const BookShipmentDTOOriginHandlingAgent = {
    China: 'china',
    Denmark: 'denmark',
    Germany: 'germany',
    Spain: 'spain',
    Vietnam: 'vietnam',
    Netherlands: 'netherlands',
    Poland: 'poland',
    Italy: 'italy',
    Korman: 'korman',
    Hls: 'hls',
    Ewl: 'ewl',
    Kbl: 'kbl',
    Atn: 'atn',
    Linkindia: 'linkindia',
    Rifline: 'rifline',
    SteinFreight: 'steinFreight',
    Fhchina: 'fhchina',
    Fhvietnam: 'fhvietnam',
    Ncs: 'ncs',
    QuantumLogistics: 'quantumLogistics',
    ZeusGlobalLogistics: 'zeusGlobalLogistics',
    IbcInternationaleSpeditionGmbH: 'ibcInternationaleSpeditionGmbH',
    Exsan: 'exsan',
    NowportsBrasilLtda: 'nowportsBrasilLTDA',
    Unimasters: 'unimasters',
    TotalExpress: 'totalExpress',
    NowportsChileSpa: 'nowportsChileSpa',
    NowportsColombiaSas: 'nowportsColombiaSas',
    PelmiSpolSro: 'pelmiSpolSRO',
    IsaNordicOy: 'isaNordicOy',
    FmiGroupe: 'fmiGroupe',
    WorldTransportOverseasHellas: 'worldTransportOverseasHellas',
    CargoManLtd: 'cargoManLtd',
    ApLogistics: 'apLogistics',
    SanyoLogisticsInc: 'sanyoLogisticsInc',
    TransmarinLogistics: 'transmarinLogistics',
    JscLimarkoMaritimeAgency: 'jscLimarkoMaritimeAgency',
    Nowports: 'nowports',
    InterScanSeaAndAirNorwayAs: 'interScanSeaAndAirNorwayAS',
    NowportsPanama: 'nowportsPanama',
    SmtGlobalLogisticsInc: 'smtGlobalLogisticsInc',
    NvoxpressTransitariosLda: 'nvoxpressTransitariosLda',
    InLineFreightSolutions: 'inLineFreightSolutions',
    InterNordicTransportAb: 'interNordicTransportAB',
    OctagonFreightServicesLlc: 'octagonFreightServicesLLC',
    XenorUk: 'xenorUK',
    WizFreight: 'WIZFreight',
    PtSmasLogisticWorldwide: 'ptSmasLogisticWorldwide',
    QuantermLogisticsMalaysia: 'QuantermLogisticsMalaysia',
    CombinedFreightInternational: 'CombinedFreightInternational',
    LigiLogistics: 'LigiLogistics'
};
const BookShipmentDTODestinationHandlingAgent = {
    China: 'china',
    Denmark: 'denmark',
    Germany: 'germany',
    Spain: 'spain',
    Vietnam: 'vietnam',
    Netherlands: 'netherlands',
    Poland: 'poland',
    Italy: 'italy',
    Korman: 'korman',
    Hls: 'hls',
    Ewl: 'ewl',
    Kbl: 'kbl',
    Atn: 'atn',
    Linkindia: 'linkindia',
    Rifline: 'rifline',
    SteinFreight: 'steinFreight',
    Fhchina: 'fhchina',
    Fhvietnam: 'fhvietnam',
    Ncs: 'ncs',
    QuantumLogistics: 'quantumLogistics',
    ZeusGlobalLogistics: 'zeusGlobalLogistics',
    IbcInternationaleSpeditionGmbH: 'ibcInternationaleSpeditionGmbH',
    Exsan: 'exsan',
    NowportsBrasilLtda: 'nowportsBrasilLTDA',
    Unimasters: 'unimasters',
    TotalExpress: 'totalExpress',
    NowportsChileSpa: 'nowportsChileSpa',
    NowportsColombiaSas: 'nowportsColombiaSas',
    PelmiSpolSro: 'pelmiSpolSRO',
    IsaNordicOy: 'isaNordicOy',
    FmiGroupe: 'fmiGroupe',
    WorldTransportOverseasHellas: 'worldTransportOverseasHellas',
    CargoManLtd: 'cargoManLtd',
    ApLogistics: 'apLogistics',
    SanyoLogisticsInc: 'sanyoLogisticsInc',
    TransmarinLogistics: 'transmarinLogistics',
    JscLimarkoMaritimeAgency: 'jscLimarkoMaritimeAgency',
    Nowports: 'nowports',
    InterScanSeaAndAirNorwayAs: 'interScanSeaAndAirNorwayAS',
    NowportsPanama: 'nowportsPanama',
    SmtGlobalLogisticsInc: 'smtGlobalLogisticsInc',
    NvoxpressTransitariosLda: 'nvoxpressTransitariosLda',
    InLineFreightSolutions: 'inLineFreightSolutions',
    InterNordicTransportAb: 'interNordicTransportAB',
    OctagonFreightServicesLlc: 'octagonFreightServicesLLC',
    XenorUk: 'xenorUK',
    WizFreight: 'WIZFreight',
    PtSmasLogisticWorldwide: 'ptSmasLogisticWorldwide',
    QuantermLogisticsMalaysia: 'QuantermLogisticsMalaysia',
    CombinedFreightInternational: 'CombinedFreightInternational',
    LigiLogistics: 'LigiLogistics'
};
const BookingDTOState = {
    Open: 'open',
    Authorized: 'authorized',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Nominated: 'nominated',
    CarrierContacted: 'carrierContacted',
    Confirmed: 'confirmed'
};
const BookingDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const BookingDTOInitiatorParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const BookingDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const BookingDTOTransportMode = {
    Sea: 'sea',
    Air: 'air',
    Rail: 'rail',
    Road: 'road'
};
const BookingDTOShipmentProcess = {
    NotStarted: 'notStarted',
    Unrequired: 'unrequired',
    Discarded: 'discarded',
    InProgress: 'inProgress',
    Failed: 'failed',
    Succeeded: 'succeeded'
};
const BookingDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const BookingDTOTransportScope = {
    OriginPortToDestinationPort: 'originPortToDestinationPort',
    OriginPortToDestinationDoor: 'originPortToDestinationDoor',
    OriginDoorToDestinationDoor: 'originDoorToDestinationDoor',
    OriginDoorToDestinationPort: 'originDoorToDestinationPort',
    OriginDoorToOriginPort: 'originDoorToOriginPort',
    DestinationPortToDestinationDoor: 'destinationPortToDestinationDoor'
};
const BookingDTOShipmentVersion = {
    V1: 'v1',
    V2: 'v2'
};
const BookingDTOBookingVersion = {
    V1: 'v1',
    V2: 'v2',
    V3: 'v3'
};
const BookingDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const BookingDTOCustomsOriginCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const BookingDTOCustomsDestinationCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const BookingDTOIncotermCode = {
    Exw: 'EXW',
    Fca: 'FCA',
    FcaLw: 'FCA_LW',
    FcaT: 'FCA_T',
    Fas: 'FAS',
    Fob: 'FOB',
    Cfr: 'CFR',
    Cif: 'CIF',
    Cpt: 'CPT',
    Cip: 'CIP',
    Dpu: 'DPU',
    Dap: 'DAP',
    Ddp: 'DDP'
};
const BookingDTOIncotermNamedPlaceOfDelivery = {
    LoadingWarehouse: 'loadingWarehouse',
    Terminal: 'terminal'
};
const BookingPublishedDTOState = {
    Open: 'open',
    Authorized: 'authorized',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Nominated: 'nominated',
    CarrierContacted: 'carrierContacted',
    Confirmed: 'confirmed'
};
const BookingPublishedDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const BookingPublishedDTOInitiatorParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const BookingPublishedDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const BookingPublishedDTOTransportMode = {
    Sea: 'sea',
    Air: 'air',
    Rail: 'rail',
    Road: 'road'
};
const BookingPublishedDTOShipmentProcess = {
    NotStarted: 'notStarted',
    Unrequired: 'unrequired',
    Discarded: 'discarded',
    InProgress: 'inProgress',
    Failed: 'failed',
    Succeeded: 'succeeded'
};
const BookingPublishedDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const BookingPublishedDTOTransportScope = {
    OriginPortToDestinationPort: 'originPortToDestinationPort',
    OriginPortToDestinationDoor: 'originPortToDestinationDoor',
    OriginDoorToDestinationDoor: 'originDoorToDestinationDoor',
    OriginDoorToDestinationPort: 'originDoorToDestinationPort',
    OriginDoorToOriginPort: 'originDoorToOriginPort',
    DestinationPortToDestinationDoor: 'destinationPortToDestinationDoor'
};
const BookingPublishedDTOShipmentVersion = {
    V1: 'v1',
    V2: 'v2'
};
const BookingPublishedDTOBookingVersion = {
    V1: 'v1',
    V2: 'v2',
    V3: 'v3'
};
const BookingPublishedDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const CanceledDTOType = {
    Canceled: 'canceled'
};
const CarriageMode = {
    Sea: 'sea'
};
const ComplianceCheckRequestedDTOType = {
    ComplianceCheckRequested: 'complianceCheckRequested'
};
const ComplianceCheckUpdatedDTOType = {
    ComplianceCheckUpdated: 'complianceCheckUpdated'
};
const ConfirmationRevisedDTOType = {
    ConfirmationRevised: 'confirmationRevised'
};
const ConfirmedDTOType = {
    Confirmed: 'confirmed'
};
const ContactedDTOType = {
    Contacted: 'contacted'
};
const ContactedRevisedDTOType = {
    ContactedRevised: 'contactedRevised'
};
const CreateBookingDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const CreateBookingDTOInitiatorParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const CreateBookingDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const CreateBookingDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const CreateBookingDTOTransportMode = {
    Sea: 'sea',
    Air: 'air',
    Rail: 'rail',
    Road: 'road'
};
const CreateBookingDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const CreateBookingDTOTransportScope = {
    OriginPortToDestinationPort: 'originPortToDestinationPort',
    OriginPortToDestinationDoor: 'originPortToDestinationDoor',
    OriginDoorToDestinationDoor: 'originDoorToDestinationDoor',
    OriginDoorToDestinationPort: 'originDoorToDestinationPort',
    OriginDoorToOriginPort: 'originDoorToOriginPort',
    DestinationPortToDestinationDoor: 'destinationPortToDestinationDoor'
};
const CreateBookingDTOCustomsOriginCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const CreateBookingDTOCustomsDestinationCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const CreateBookingWithManualQuoteRequestDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const CreateBookingWithManualQuoteRequestDTOInitiatorParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const CreateBookingWithManualQuoteRequestDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const CreateBookingWithManualQuoteRequestDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const CreateBookingWithManualQuoteRequestDTOTransportMode = {
    Sea: 'sea',
    Air: 'air',
    Rail: 'rail',
    Road: 'road'
};
const CreateBookingWithManualQuoteRequestDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const CreateBookingWithManualQuoteRequestDTOTransportScope = {
    OriginPortToDestinationPort: 'originPortToDestinationPort',
    OriginPortToDestinationDoor: 'originPortToDestinationDoor',
    OriginDoorToDestinationDoor: 'originDoorToDestinationDoor',
    OriginDoorToDestinationPort: 'originDoorToDestinationPort',
    OriginDoorToOriginPort: 'originDoorToOriginPort',
    DestinationPortToDestinationDoor: 'destinationPortToDestinationDoor'
};
const CreateBookingWithManualQuoteRequestDTOManualQuoteRequestDataBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const CreatedDTOType = {
    Created: 'created'
};
const CurrencyDTOCode = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const CustomQuoteRequestDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const CustomQuoteRequestDTOIncotermCode = {
    Exw: 'EXW',
    Fca: 'FCA',
    FcaLw: 'FCA_LW',
    FcaT: 'FCA_T',
    Fas: 'FAS',
    Fob: 'FOB',
    Cfr: 'CFR',
    Cif: 'CIF',
    Cpt: 'CPT',
    Cip: 'CIP',
    Dpu: 'DPU',
    Dap: 'DAP',
    Ddp: 'DDP'
};
const CustomQuoteRequestDTOIncotermNamedPlaceOfDelivery = {
    LoadingWarehouse: 'loadingWarehouse',
    Terminal: 'terminal'
};
const CustomsDTOOriginCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const CustomsDTODestinationCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const DestinationDoorWaypointDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const DestinationDoorWaypointType = {
    DestinationDoor: 'destinationDoor'
};
const DestinationPortWaypointDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const DestinationPortWaypointType = {
    DestinationPort: 'destinationPort'
};
const ExchangeRateDTOSource = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const ExchangeRateDTOTarget = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const ExplicitlyApprovedByControllingPartyDTOType = {
    ExplicitlyApprovedByControllingParty: 'explicitlyApprovedByControllingParty'
};
const GetPricesDTOTransportType = {
    Fcl: 'fcl',
    Lcl: 'lcl'
};
const GetPricesDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const GetPricesDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const GetPricesDTOCustomsOriginCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const GetPricesDTOCustomsDestinationCustomsType = {
    Standard: 'standard',
    Fiscal: 'fiscal',
    T1: 't1',
    T1Only: 't1_only',
    T2: 't2',
    T2Only: 't2_only'
};
const GetPricingResponseDTOPricingType = {
    Pricing: 'pricing',
    Quotation: 'quotation'
};
const ImplicitlyApprovedByNonControllingPartyDTOType = {
    ImplicitlyApprovedByNonControllingParty: 'implicitlyApprovedByNonControllingParty'
};
const IncotermDTOCode = {
    Exw: 'EXW',
    Fca: 'FCA',
    FcaLw: 'FCA_LW',
    FcaT: 'FCA_T',
    Fas: 'FAS',
    Fob: 'FOB',
    Cfr: 'CFR',
    Cif: 'CIF',
    Cpt: 'CPT',
    Cip: 'CIP',
    Dpu: 'DPU',
    Dap: 'DAP',
    Ddp: 'DDP'
};
const IncotermDTONamedPlaceOfDelivery = {
    LoadingWarehouse: 'loadingWarehouse',
    Terminal: 'terminal'
};
const InsuranceDTOCommodityClass = {
    A: 'A',
    B: 'B',
    C: 'C'
};
const InsuranceDTOValueCode = {
    Percent: '%',
    Aed: 'AED',
    Aud: 'AUD',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Eek: 'EEK',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Krw: 'KRW',
    Kwd: 'KWD',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Nok: 'NOK',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Usd: 'USD',
    Vnd: 'VND',
    Zar: 'ZAR'
};
const LocationDTOType = {
    OriginPort: 'originPort',
    OriginDoor: 'originDoor',
    DestinationDoor: 'destinationDoor',
    DestinationPort: 'destinationPort'
};
const MoneyDTOCode = {
    Percent: '%',
    Aed: 'AED',
    Aud: 'AUD',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Eek: 'EEK',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Krw: 'KRW',
    Kwd: 'KWD',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Nok: 'NOK',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Usd: 'USD',
    Vnd: 'VND',
    Zar: 'ZAR'
};
const NominatedDTOType = {
    Nominated: 'nominated'
};
const NominationRevisedDTOType = {
    NominationRevised: 'nominationRevised'
};
const OfferRequestedDTOType = {
    OfferRequested: 'offerRequested'
};
const OriginDoorWaypointDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const OriginDoorWaypointType = {
    OriginDoor: 'originDoor'
};
const OriginPortWaypointDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const OriginPortWaypointType = {
    OriginPort: 'originPort'
};
const PackageDTOType = {
    Cartons: 'CARTONS',
    Pieces: 'PIECES',
    Packages: 'PACKAGES',
    Cases: 'CASES',
    Bags: 'BAGS',
    Boxes: 'BOXES',
    Crates: 'CRATES',
    Rolls: 'ROLLS',
    Units: 'UNITS',
    Drums: 'DRUMS',
    Bundles: 'BUNDLES',
    Bales: 'BALES',
    Tanks: 'TANKS',
    Coils: 'COILS'
};
const PartialUpdateBookingDTOBookingParty = {
    Buyer: 'buyer',
    Seller: 'seller',
    BuyerAgent: 'buyerAgent',
    SellerAgent: 'sellerAgent'
};
const PartialUpdateBookingDTOInitiatorParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const PartialUpdateBookingDTOControllingParty = {
    Shipper: 'shipper',
    Consignee: 'consignee'
};
const PartialUpdateBookingDTOServiceType = {
    CyCy: 'CY/CY',
    CyCfs: 'CY/CFS',
    CfsCfs: 'CFS/CFS',
    CfsCy: 'CFS/CY'
};
const PartialUpdateBookingDTOTransportScope = {
    OriginPortToDestinationPort: 'originPortToDestinationPort',
    OriginPortToDestinationDoor: 'originPortToDestinationDoor',
    OriginDoorToDestinationDoor: 'originDoorToDestinationDoor',
    OriginDoorToDestinationPort: 'originDoorToDestinationPort',
    OriginDoorToOriginPort: 'originDoorToOriginPort',
    DestinationPortToDestinationDoor: 'destinationPortToDestinationDoor'
};
const PricingLineItemDTOUnit = {
    Container: 'container',
    Shipment: 'shipment',
    Teu: 'teu',
    Bl: 'bl',
    Hscode: 'hscode'
};
const PricingLineItemDTOExchangeRateSource = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const PricingLineItemDTOExchangeRateTarget = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const PricingLineItemDTORateCode = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const PricingLineItemDTOTotalCode = {
    Percent: '%',
    Aed: 'AED',
    Afn: 'AFN',
    Aud: 'AUD',
    Azn: 'AZN',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bnd: 'BND',
    Brl: 'BRL',
    Btc: 'BTC',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Crc: 'CRC',
    Cup: 'CUP',
    Cyp: 'CYP',
    Czk: 'CZK',
    Dkk: 'DKK',
    Dzd: 'DZD',
    Eek: 'EEK',
    Egp: 'EGP',
    Eur: 'EUR',
    Fjd: 'FJD',
    Gbp: 'GBP',
    Gel: 'GEL',
    Hkd: 'HKD',
    Hrk: 'HRK',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kgs: 'KGS',
    Khr: 'KHR',
    Krw: 'KRW',
    Kwd: 'KWD',
    Lkr: 'LKR',
    Ltl: 'LTL',
    Lvl: 'LVL',
    Mad: 'MAD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mtl: 'MTL',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Qar: 'QAR',
    Rol: 'ROL',
    Ron: 'RON',
    Rub: 'RUB',
    Sar: 'SAR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Sit: 'SIT',
    Skk: 'SKK',
    Std: 'STD',
    Thb: 'THB',
    Trl: 'TRL',
    Try: 'TRY',
    Twd: 'TWD',
    Uah: 'UAH',
    Usd: 'USD',
    Vnd: 'VND',
    Xbt: 'XBT',
    Xpf: 'XPF',
    Zar: 'ZAR'
};
const PricingUpdatedDTOType = {
    PricingUpdated: 'pricingUpdated'
};
const PricingWithoutMetaDTOServiceType = {
    CustomsImport: 'customs-import',
    CustomsExport: 'customs-export',
    DoorCarriageDestination: 'door-carriage-destination',
    DoorCarriageOrigin: 'door-carriage-origin',
    SeaFreight: 'sea-freight',
    Insurance: 'insurance',
    Sustainability: 'sustainability'
};
const QuotedDTOType = {
    Quoted: 'quoted'
};
const RejectedDTOType = {
    Rejected: 'rejected'
};
const ShippedDTOType = {
    Shipped: 'shipped'
};
const SystemFailedDTOType = {
    SystemFailed: 'systemFailed'
};
const UpdatedDTOType = {
    Updated: 'updated'
};
const WaypointBaseDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const WaypointBaseDTODestinationType = {
    OriginPort: 'originPort',
    OriginDoor: 'originDoor',
    DestinationDoor: 'destinationDoor',
    DestinationPort: 'destinationPort'
};
const WaypointBaseDTOOriginType = {
    OriginPort: 'originPort',
    OriginDoor: 'originDoor',
    DestinationDoor: 'destinationDoor',
    DestinationPort: 'destinationPort'
};
const WaypointConnectionBaseDTOTransportMode = {
    Rail: 'rail',
    Truck: 'truck',
    Barge: 'barge',
    Air: 'air',
    Sea: 'sea'
};
const WaypointTypes = {
    OriginDoor: 'originDoor',
    OriginPort: 'originPort',
    DestinationPort: 'destinationPort',
    DestinationDoor: 'destinationDoor'
};

exports.AllowedBookingRequestDTOIncoterm = AllowedBookingRequestDTOIncoterm;
exports.AllowedBookingRequestDTOTransportMode = AllowedBookingRequestDTOTransportMode;
exports.AllowedBookingRequestDTOTransportType = AllowedBookingRequestDTOTransportType;
exports.AssignedOpsChangedDTOType = AssignedOpsChangedDTOType;
exports.AssignmentDetailsDTOAssignedSide = AssignmentDetailsDTOAssignedSide;
exports.AuthorizedDTOType = AuthorizedDTOType;
exports.BookShipmentDTODestinationHandlingAgent = BookShipmentDTODestinationHandlingAgent;
exports.BookShipmentDTOOriginHandlingAgent = BookShipmentDTOOriginHandlingAgent;
exports.BookingDTOBookingParty = BookingDTOBookingParty;
exports.BookingDTOBookingVersion = BookingDTOBookingVersion;
exports.BookingDTOControllingParty = BookingDTOControllingParty;
exports.BookingDTOCustomsDestinationCustomsType = BookingDTOCustomsDestinationCustomsType;
exports.BookingDTOCustomsOriginCustomsType = BookingDTOCustomsOriginCustomsType;
exports.BookingDTOIncotermCode = BookingDTOIncotermCode;
exports.BookingDTOIncotermNamedPlaceOfDelivery = BookingDTOIncotermNamedPlaceOfDelivery;
exports.BookingDTOInitiatorParty = BookingDTOInitiatorParty;
exports.BookingDTOServiceType = BookingDTOServiceType;
exports.BookingDTOShipmentProcess = BookingDTOShipmentProcess;
exports.BookingDTOShipmentVersion = BookingDTOShipmentVersion;
exports.BookingDTOState = BookingDTOState;
exports.BookingDTOTransportMode = BookingDTOTransportMode;
exports.BookingDTOTransportScope = BookingDTOTransportScope;
exports.BookingDTOTransportType = BookingDTOTransportType;
exports.BookingPublishedDTOBookingParty = BookingPublishedDTOBookingParty;
exports.BookingPublishedDTOBookingVersion = BookingPublishedDTOBookingVersion;
exports.BookingPublishedDTOControllingParty = BookingPublishedDTOControllingParty;
exports.BookingPublishedDTOInitiatorParty = BookingPublishedDTOInitiatorParty;
exports.BookingPublishedDTOServiceType = BookingPublishedDTOServiceType;
exports.BookingPublishedDTOShipmentProcess = BookingPublishedDTOShipmentProcess;
exports.BookingPublishedDTOShipmentVersion = BookingPublishedDTOShipmentVersion;
exports.BookingPublishedDTOState = BookingPublishedDTOState;
exports.BookingPublishedDTOTransportMode = BookingPublishedDTOTransportMode;
exports.BookingPublishedDTOTransportScope = BookingPublishedDTOTransportScope;
exports.BookingPublishedDTOTransportType = BookingPublishedDTOTransportType;
exports.CanceledDTOType = CanceledDTOType;
exports.CarriageMode = CarriageMode;
exports.ComplianceCheckRequestedDTOType = ComplianceCheckRequestedDTOType;
exports.ComplianceCheckUpdatedDTOType = ComplianceCheckUpdatedDTOType;
exports.ConfirmationRevisedDTOType = ConfirmationRevisedDTOType;
exports.ConfirmedDTOType = ConfirmedDTOType;
exports.ContactedDTOType = ContactedDTOType;
exports.ContactedRevisedDTOType = ContactedRevisedDTOType;
exports.CreateBookingDTOBookingParty = CreateBookingDTOBookingParty;
exports.CreateBookingDTOControllingParty = CreateBookingDTOControllingParty;
exports.CreateBookingDTOCustomsDestinationCustomsType = CreateBookingDTOCustomsDestinationCustomsType;
exports.CreateBookingDTOCustomsOriginCustomsType = CreateBookingDTOCustomsOriginCustomsType;
exports.CreateBookingDTOInitiatorParty = CreateBookingDTOInitiatorParty;
exports.CreateBookingDTOServiceType = CreateBookingDTOServiceType;
exports.CreateBookingDTOTransportMode = CreateBookingDTOTransportMode;
exports.CreateBookingDTOTransportScope = CreateBookingDTOTransportScope;
exports.CreateBookingDTOTransportType = CreateBookingDTOTransportType;
exports.CreateBookingWithManualQuoteRequestDTOBookingParty = CreateBookingWithManualQuoteRequestDTOBookingParty;
exports.CreateBookingWithManualQuoteRequestDTOControllingParty = CreateBookingWithManualQuoteRequestDTOControllingParty;
exports.CreateBookingWithManualQuoteRequestDTOInitiatorParty = CreateBookingWithManualQuoteRequestDTOInitiatorParty;
exports.CreateBookingWithManualQuoteRequestDTOManualQuoteRequestDataBookingParty = CreateBookingWithManualQuoteRequestDTOManualQuoteRequestDataBookingParty;
exports.CreateBookingWithManualQuoteRequestDTOServiceType = CreateBookingWithManualQuoteRequestDTOServiceType;
exports.CreateBookingWithManualQuoteRequestDTOTransportMode = CreateBookingWithManualQuoteRequestDTOTransportMode;
exports.CreateBookingWithManualQuoteRequestDTOTransportScope = CreateBookingWithManualQuoteRequestDTOTransportScope;
exports.CreateBookingWithManualQuoteRequestDTOTransportType = CreateBookingWithManualQuoteRequestDTOTransportType;
exports.CreatedDTOType = CreatedDTOType;
exports.CurrencyDTOCode = CurrencyDTOCode;
exports.CustomQuoteRequestDTOBookingParty = CustomQuoteRequestDTOBookingParty;
exports.CustomQuoteRequestDTOIncotermCode = CustomQuoteRequestDTOIncotermCode;
exports.CustomQuoteRequestDTOIncotermNamedPlaceOfDelivery = CustomQuoteRequestDTOIncotermNamedPlaceOfDelivery;
exports.CustomsDTODestinationCustomsType = CustomsDTODestinationCustomsType;
exports.CustomsDTOOriginCustomsType = CustomsDTOOriginCustomsType;
exports.DestinationDoorWaypointDTOTransportMode = DestinationDoorWaypointDTOTransportMode;
exports.DestinationDoorWaypointType = DestinationDoorWaypointType;
exports.DestinationPortWaypointDTOTransportMode = DestinationPortWaypointDTOTransportMode;
exports.DestinationPortWaypointType = DestinationPortWaypointType;
exports.ExchangeRateDTOSource = ExchangeRateDTOSource;
exports.ExchangeRateDTOTarget = ExchangeRateDTOTarget;
exports.ExplicitlyApprovedByControllingPartyDTOType = ExplicitlyApprovedByControllingPartyDTOType;
exports.GetPricesDTOControllingParty = GetPricesDTOControllingParty;
exports.GetPricesDTOCustomsDestinationCustomsType = GetPricesDTOCustomsDestinationCustomsType;
exports.GetPricesDTOCustomsOriginCustomsType = GetPricesDTOCustomsOriginCustomsType;
exports.GetPricesDTOServiceType = GetPricesDTOServiceType;
exports.GetPricesDTOTransportType = GetPricesDTOTransportType;
exports.GetPricingResponseDTOPricingType = GetPricingResponseDTOPricingType;
exports.ImplicitlyApprovedByNonControllingPartyDTOType = ImplicitlyApprovedByNonControllingPartyDTOType;
exports.IncotermDTOCode = IncotermDTOCode;
exports.IncotermDTONamedPlaceOfDelivery = IncotermDTONamedPlaceOfDelivery;
exports.InsuranceDTOCommodityClass = InsuranceDTOCommodityClass;
exports.InsuranceDTOValueCode = InsuranceDTOValueCode;
exports.LocationDTOType = LocationDTOType;
exports.MoneyDTOCode = MoneyDTOCode;
exports.NominatedDTOType = NominatedDTOType;
exports.NominationRevisedDTOType = NominationRevisedDTOType;
exports.OfferRequestedDTOType = OfferRequestedDTOType;
exports.OriginDoorWaypointDTOTransportMode = OriginDoorWaypointDTOTransportMode;
exports.OriginDoorWaypointType = OriginDoorWaypointType;
exports.OriginPortWaypointDTOTransportMode = OriginPortWaypointDTOTransportMode;
exports.OriginPortWaypointType = OriginPortWaypointType;
exports.PackageDTOType = PackageDTOType;
exports.PartialUpdateBookingDTOBookingParty = PartialUpdateBookingDTOBookingParty;
exports.PartialUpdateBookingDTOControllingParty = PartialUpdateBookingDTOControllingParty;
exports.PartialUpdateBookingDTOInitiatorParty = PartialUpdateBookingDTOInitiatorParty;
exports.PartialUpdateBookingDTOServiceType = PartialUpdateBookingDTOServiceType;
exports.PartialUpdateBookingDTOTransportScope = PartialUpdateBookingDTOTransportScope;
exports.PricingLineItemDTOExchangeRateSource = PricingLineItemDTOExchangeRateSource;
exports.PricingLineItemDTOExchangeRateTarget = PricingLineItemDTOExchangeRateTarget;
exports.PricingLineItemDTORateCode = PricingLineItemDTORateCode;
exports.PricingLineItemDTOTotalCode = PricingLineItemDTOTotalCode;
exports.PricingLineItemDTOUnit = PricingLineItemDTOUnit;
exports.PricingUpdatedDTOType = PricingUpdatedDTOType;
exports.PricingWithoutMetaDTOServiceType = PricingWithoutMetaDTOServiceType;
exports.QuotedDTOType = QuotedDTOType;
exports.RejectedDTOType = RejectedDTOType;
exports.ShippedDTOType = ShippedDTOType;
exports.SystemFailedDTOType = SystemFailedDTOType;
exports.UpdatedDTOType = UpdatedDTOType;
exports.WaypointBaseDTODestinationType = WaypointBaseDTODestinationType;
exports.WaypointBaseDTOOriginType = WaypointBaseDTOOriginType;
exports.WaypointBaseDTOTransportMode = WaypointBaseDTOTransportMode;
exports.WaypointConnectionBaseDTOTransportMode = WaypointConnectionBaseDTOTransportMode;
exports.WaypointTypes = WaypointTypes;
